export default "__VITE_ASSET__71ece9e7__"